<div [appStoryblok]="_editable">
  <div class="container-xl">
    <div class="row gap">
      <div class="col-12 col-lg-4">
        <h1 class="mb-3 display-1 text-uppercase">
          Daily<br />
          Journal
        </h1>
        <a class="text-uppercase mb-5" [routerLink]="['/blogs']">See All ></a>
      </div>
      <div class="col-lg-8 col-12">
        <div class="row gx-0">
          <a
            class="col-12 col-md-6 article-content action p-4 d-flex flex-column"
            [ngClass]="{ 'd-none d-md-flex': !first }"
            [storyblokLink]="entry"
            *ngFor="let entry of _articles; let first = first"
          >
            <h3 *ngIf="entry?.name">{{ entry.name }}</h3>
            <div
              *ngIf="entry?.content?.excerpt"
              class="excerpt mt-auto"
              [storyblokRichText]="entry.content.excerpt"
            ></div>

            <img
              class="w-100"
              height="309"
              width="383"
              [ngSrc]="entry?.content?.teaser?.filename"
              *ngIf="entry?.content?.teaser?.filename"
            />
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
